module.exports = __webpack_public_path__ + "static/sport/bgi-swiper.5a4e87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/bgi-swiper.png
// module id = Hnog
// module chunks = 0